/**
 * i18n de Costos y stock (v3) — área PLATO (la ficha del plato: costear): claves cs.plato.*.
 * Paridad exacta es/en/pt (claves y placeholders {x}): la controla src/v2/i18n/parity.test.js.
 * Los prefijos por área los controla costsV3.test.js (dos áreas no pueden pisarse).
 *
 * Vocabulario (propuesta §2.6): "ingrediente" dentro de la receta, "Insumo" en listas y fichas;
 * Limpieza (no "merma"); Gastos de cocina; Tu meta; "Te queda $X" + "antes de sueldos y alquiler".
 * Lo común (estados, unid., stock, Guardar/Reintentar) está en cs.shell.* y no se repite acá.
 */
const plato = {
  es: {
    "cs.plato.notFound.title": "No encontramos este plato",
    "cs.plato.notFound.body": "Puede que lo hayas sacado de la carta.",
    "cs.plato.notFound.back": "Volver a Platos",
    "cs.plato.sellsAt": "La vendés a",
    "cs.plato.draft.banner": "Tenés cambios sin guardar en este plato.",
    "cs.plato.draft.keep": "Seguir",
    "cs.plato.draft.discard": "Descartar",
    "cs.plato.discarded": "Descartaste los cambios",
    "cs.plato.undo": "Deshacer",
    "cs.plato.undoClose": "Cerrar el aviso",

    "cs.plato.mode.label": "¿Cómo lo costeás?",
    "cs.plato.mode.recipe": "Con receta",
    "cs.plato.mode.recipeSub": "con ingredientes",
    "cs.plato.mode.resale": "Se vende tal cual",
    "cs.plato.mode.resaleSub": "bebidas, lo comprado",
    "cs.plato.mode.quick": "Costo aproximado",
    "cs.plato.mode.quickSub": "un número",
    "cs.plato.say.recipe": "Sabés qué te come la ganancia.",
    "cs.plato.say.recipeStock": "Sabés qué te come la ganancia y descuenta del stock cada vez que se vende.",
    "cs.plato.say.resale": "Para bebidas y lo que comprás hecho.",
    "cs.plato.say.resaleStock": "Para bebidas y lo que comprás hecho. Cada venta descuenta 1.",
    "cs.plato.say.resaleSizes": "Tiene {n} tamaños: por ahora el costo y el stock son uno solo.",
    "cs.plato.say.quick": "Es más rápido, pero no vas a saber qué te come la ganancia.",
    "cs.plato.say.quickStock": "Así este plato no descuenta del stock.",
    "cs.plato.say.quickStockTip": "Si querés que baje solo, cargale la receta.",

    "cs.plato.recipe.title": "¿Qué lleva?",
    "cs.plato.recipe.search": "Agregá un ingrediente: muzza, harina, huevo…",
    "cs.plato.recipe.searchShort": "Agregá un ingrediente…",
    "cs.plato.recipe.resultsAria": "Ingredientes que coinciden",
    "cs.plato.recipe.empty": "Todavía no tiene ingredientes. Escribí arriba y elegí: la unidad y una cantidad típica vienen puestas.",
    "cs.plato.recipe.inRecipe": "ya está en la receta",
    "cs.plato.recipe.prep": "Preparado",
    "cs.plato.recipe.preset": "nuevo · se compra por {unit}",
    "cs.plato.recipe.create": "Crear \"{name}\"",
    "cs.plato.recipe.createSub": "te pide el precio",

    "cs.plato.line.qtyAria": "Cantidad de {name}, en {unit}",
    "cs.plato.line.less": "Menos {name}",
    "cs.plato.line.more": "Más {name}",
    "cs.plato.line.menuAria": "Más opciones de {name}",
    "cs.plato.line.waste": "+{n}% limpieza",
    "cs.plato.line.wasteTitle": "Limpieza: lo que se tira al prepararlo",
    "cs.plato.line.wasteNone": "Nada",
    "cs.plato.line.prepSub": "Preparado · {price}",
    "cs.plato.line.echo": "= {qty}",
    "cs.plato.line.unreadable": "No se entiende el número",
    "cs.plato.line.needQty": "Poné cuánto lleva",
    "cs.plato.line.exact": "Cantidad exacta",
    "cs.plato.line.exactTitle": "Cantidad exacta de {name}",
    "cs.plato.line.exactApply": "Listo",
    "cs.plato.line.remove": "Quitar de la receta",
    "cs.plato.line.removed": "Quitaste {name}",

    "cs.plato.broken.sub": "{qty} · lo comprás por {buy}",
    "cs.plato.broken.unit": "Está en {lineUnit} y lo comprás por {buy}: no suma ni descuenta.",
    "cs.plato.broken.unitNoStock": "Está en {lineUnit} y lo comprás por {buy}: no suma al costo.",
    "cs.plato.broken.fix": "Arreglar",
    "cs.plato.broken.measureHere": "Pasarlo a {unit} acá",
    "cs.plato.broken.deleted": "Este insumo ya no existe: no suma.",
    "cs.plato.broken.deletedPrep": "Este preparado ya no existe: no suma.",
    "cs.plato.broken.inner": "Adentro de este preparado hay una línea rota: no suma entero.",
    "cs.plato.broken.remove": "Quitar",
    "cs.plato.missing.text": "Sin precio no suma: el plato queda incompleto.",
    "cs.plato.missing.amountText": "Sin cantidad no suma: poné cuánto lleva.",
    "cs.plato.missing.prepText": "Al preparado le falta el precio de un ingrediente.",
    "cs.plato.missing.fix": "Poner precio",
    "cs.plato.missing.openPrep": "Ver el preparado",

    "cs.plato.new.title": "Ingrediente nuevo",
    "cs.plato.new.name": "Nombre",
    "cs.plato.new.howMuch": "¿Cuánto lo pagaste?",
    "cs.plato.new.paidAria": "Cuánto pagaste, en pesos",
    "cs.plato.new.qtyAria": "Cuánto compraste",
    "cs.plato.new.unitAria": "Unidad",
    "cs.plato.new.echo": "→ {cost}",
    "cs.plato.new.unreadable": "No se entiende el número",
    "cs.plato.new.needPrice": "Poné cuánto pagaste, o tocá \"Lo cargo después\".",
    "cs.plato.new.later": "No sé el precio: lo cargo después",
    "cs.plato.new.add": "Agregar",
    "cs.plato.new.dup": "Ya tenés \"{name}\" en Insumos.",
    "cs.plato.new.useIt": "Usar ese",
    "cs.plato.new.createdNoPrice": "Creaste {name} sin precio: el plato queda incompleto hasta que lo cargues.",
    "cs.plato.new.failed": "No se guardó el ingrediente. Probá de nuevo.",
    "cs.plato.paid": "Pagaste",
    "cs.plato.for": "por",

    "cs.plato.resale.title": "¿Cuánto te sale cada uno?",
    "cs.plato.resale.paidAria": "Cuánto pagaste, en pesos",
    "cs.plato.resale.nAria": "Cuántos trae",
    "cs.plato.resale.hint": "Lo que pagaste por el pack o la caja, y cuántos trae.",
    "cs.plato.resale.match": "Ya tenés \"{name}\" en Insumos ({price} c/u). ¿Es el mismo?",
    "cs.plato.resale.matchYes": "Sí, es el mismo",
    "cs.plato.resale.matchNo": "No, es otro",
    "cs.plato.resale.tracked": "Se controla (hay {qty}): cada venta descuenta 1.",
    "cs.plato.resale.trackedUnc": "Se controla, pero todavía no lo contaste.",
    "cs.plato.resale.trackedOversold": "Se controla. Se vendió de más: contalo de nuevo.",
    "cs.plato.resale.track": "Controlar el stock",
    "cs.plato.resale.have": "¿Cuántos tenés ahora?",
    "cs.plato.resale.haveHint": "Contá lo de la heladera y el depósito.",

    "cs.plato.quick.label": "¿Cuánto te sale cada plato, más o menos?",
    "cs.plato.quick.suffix": "por plato",
    "cs.plato.quick.hint": "Un número redondo alcanza.",

    "cs.plato.hero.title": "Te queda de cada uno",
    "cs.plato.hero.none": "Todavía no tiene costo. Elegí cómo costearlo: con receta, tal cual o un número aproximado.",
    "cs.plato.hero.ingredients": "Ingredientes",
    "cs.plato.hero.approxCost": "Costo aproximado",
    "cs.plato.hero.kitchen": "Gastos de cocina ({pct}%)",
    "cs.plato.hero.queda": "Te queda",
    "cs.plato.hero.beforeWages": "antes de sueldos y alquiler",
    "cs.plato.hero.incompleteMissing": "Incompleto: falta el precio de {name}. Lo que te queda es menos.",
    "cs.plato.hero.incompleteAmount": "Incompleto: falta cuánto lleva de {name}. Lo que te queda es menos.",
    "cs.plato.hero.incompleteBroken": "Incompleto: \"{name}\" no suma. Lo que te queda es menos.",
    "cs.plato.hero.noPrice": "La carta no tiene precio para este plato: ponéselo en el editor de la carta.",
    "cs.plato.hero.worstOf": "con el precio de {label}",
    "cs.plato.hero.priceN": "Precio {n}",
    "cs.plato.hero.sizeQueda": "te queda",
    "cs.plato.hero.sizesNote2": "Misma receta para los dos tamaños (por ahora).",
    "cs.plato.hero.sizesNoteN": "Misma receta para los {n} tamaños (por ahora).",
    "cs.plato.hero.goal": "Tu meta: ingredientes hasta {pct}% del precio.",
    "cs.plato.hero.goalResale": "Tu meta para lo que revendés: hasta {pct}% del precio.",
    "cs.plato.hero.suggestPre": "Para llegar, cobralo",
    "cs.plato.hero.ok": "Vas bien.",
    "cs.plato.hero.top": "Lo que más pesa: {name}, {pct}%",
    "cs.plato.hero.copy": "Copiar precio",
    "cs.plato.hero.copyAria": "Copiar {price}",
    "cs.plato.hero.copied": "Copiado: {price}. Pegalo en el editor de la carta.",
    "cs.plato.hero.copyFail": "No se pudo copiar: es {price}.",
    "cs.plato.hero.changeGoal": "Cambiar meta",
    "cs.plato.hero.metaMark": "meta",
    "cs.plato.hero.barAria": "Ingredientes {ing}% y gastos de cocina {gastos}% del precio. Tu meta: {meta}%.",
    "cs.plato.bar.of": "de {price}",
    "cs.plato.bar.pcts": "Ingredientes {pct}% · meta {meta}%",
    "cs.plato.bar.none": "Todavía no tiene costo",
    "cs.plato.bar.noneSub": "Elegí cómo costearlo y lo ves acá.",
    "cs.plato.bar.noPrice": "La carta no tiene precio",
    "cs.plato.bar.open": "Ver el detalle de la plata",
    "cs.plato.bar.close": "Cerrar el detalle de la plata",

    "cs.plato.stock.title": "Stock de este plato",
    "cs.plato.stock.loading": "Leyendo el stock…",
    "cs.plato.stock.loadingShort": "Leyendo…",
    "cs.plato.stock.readError": "No pudimos leer el stock. Probá recargar la página.",
    "cs.plato.stock.quick": "No descuenta del stock",
    "cs.plato.stock.quickBody": "Está en costo aproximado: el sistema no sabe qué lleva.",
    "cs.plato.stock.toRecipe": "Pasar a receta",
    "cs.plato.stock.none": "Todavía no descuenta: no tiene receta.",
    "cs.plato.stock.noTracked": "No descuenta: ningún ingrediente se controla.",
    "cs.plato.stock.noTrackedBody": "Elegí en Insumos qué querés controlar y este plato va a bajar el stock solo.",
    "cs.plato.stock.chooseTracked": "Elegir qué controlar",
    "cs.plato.stock.brokenUnit": "{name} no descuenta: la unidad de la receta no coincide con la que comprás.",
    "cs.plato.stock.uncounted": "Falta contar {name}",
    "cs.plato.stock.uncountedBody": "Lo controlás pero nunca lo contaste: sin ese número no sabemos para cuántos alcanza.",
    "cs.plato.stock.stale": "Contá de nuevo {name}",
    "cs.plato.stock.staleBody": "Hace más de 4 meses que no lo contás: el número ya no es confiable.",
    "cs.plato.stock.count": "Contar",
    "cs.plato.stock.noSales": "No pudimos leer las ventas",
    "cs.plato.stock.noSalesBody": "Sin las ventas no sabemos cuánto queda.",
    "cs.plato.stock.afterSave": "Cuando guardes, este plato va a descontar del stock.",
    "cs.plato.stock.enough": "Te alcanza para {n}",
    "cs.plato.stock.limiting": "Lo primero que se acaba: {name} (hay {have} y cada uno lleva {need}).",
    "cs.plato.stock.limitingOne": "Hay {have} de {name}.",
    "cs.plato.stock.outOf": "Se terminó {name}.",
    "cs.plato.stock.oversold": "Se vendió de más {name}: contalo de nuevo.",
    "cs.plato.stock.waiter": "Así lo ve el mozo:",
    "cs.plato.stock.waiterNada": "nada (hay de sobra).",
    "cs.plato.stock.waiterNadaMin": "Con {min} o menos de {name} va a ver cuántos quedan (por ejemplo, \"Quedan 3\").",
    "cs.plato.stock.waiterNadaNoMin": "{name} no tiene aviso: sólo va a ver \"Agotado\".",
    "cs.plato.stock.waiterLow": "\"Quedan {n}\",",
    "cs.plato.stock.waiterLowWhy": "porque {name} está en su aviso o debajo ({min}).",
    "cs.plato.stock.waiterOut": "\"Agotado\"",
    "cs.plato.stock.blockOn": "y no lo puede cargar.",
    "cs.plato.stock.blockOff": "pero lo puede cargar igual. Si no querés, prendé \"No dejar vender lo agotado\" en Ajustes.",
    "cs.plato.stock.ifOutBlock": "Si se agota, no lo va a poder cargar.",
    "cs.plato.stock.ifOutNoBlock": "Si se agota, va a ver \"Agotado\" pero lo puede cargar igual.",
    "cs.plato.stock.goSettings": "Ir a Ajustes",
    "cs.plato.stock.brokenAlso": "{name} no descuenta: la unidad no coincide.",
    "cs.plato.stock.pendingAlso": "{name} todavía no entra en la cuenta: falta contarlo.",
    "cs.plato.stock.draftNote": "Es con la receta guardada: cambia cuando guardes.",

    "cs.plato.more.title": "Más opciones del plato",
    "cs.plato.more.sub": "Gastos de cocina, nota, quitar el costo",
    "cs.plato.more.kitchen": "Gastos de cocina de este plato",
    "cs.plato.more.kitchenHint": "Vacío = el de Ajustes ({pct}%). Gas, luz, descartables, condimentos.",
    "cs.plato.more.kitchenRange": "Tiene que estar entre 0 y 50.",
    "cs.plato.more.kitchenResale": "Lo que se vende tal cual no carga gastos de cocina.",
    "cs.plato.more.note": "Nota",
    "cs.plato.more.notePh": "Ej.: la porción es de 250 g",
    "cs.plato.more.remove": "Quitar el costo",
    "cs.plato.more.removeTitle": "¿Quitar el costo?",
    "cs.plato.more.removeBody": "\"{name}\" vuelve a Sin costear y se borra lo que cargaste.",
    "cs.plato.more.removeOk": "Quitar el costo",
    "cs.plato.more.removed": "Quitaste el costo de {name}",

    "cs.plato.save.clean": "Todo guardado",
    "cs.plato.save.next": "Guardar y seguir: {name}",
    "cs.plato.save.nextShort": "Guardar y seguir",
    "cs.plato.save.skip": "Seguir: {name}",
    "cs.plato.save.skipShort": "Seguir",
    "cs.plato.save.saved": "Guardaste {name}",
    "cs.plato.save.why.noLines": "Agregá al menos un ingrediente",
    "cs.plato.save.why.lineAmount": "Hay un ingrediente sin cantidad",
    "cs.plato.save.why.deletedLine": "Quitá el insumo que ya no existe",
    "cs.plato.save.why.quick": "Poné cuánto te sale",
    "cs.plato.save.why.paid": "Poné cuánto pagaste",
    "cs.plato.save.why.have": "Poné cuántos tenés",
    "cs.plato.save.why.indirect": "Revisá los gastos de cocina",

    "cs.plato.per.kg": "el kg",
    "cs.plato.per.g": "el g",
    "cs.plato.per.lt": "el litro",
    "cs.plato.per.ml": "el ml",
    "cs.plato.per.u": "c/u",
    "cs.plato.per.doc": "la docena",
    "cs.plato.unitWord.kg": "kilos",
    "cs.plato.unitWord.g": "gramos",
    "cs.plato.unitWord.lt": "litros",
    "cs.plato.unitWord.ml": "mililitros",
    "cs.plato.unitWord.u": "unidades",
    "cs.plato.unitWord.doc": "docenas",
    "cs.plato.buyWord.kg": "kilo",
    "cs.plato.buyWord.g": "gramo",
    "cs.plato.buyWord.lt": "litro",
    "cs.plato.buyWord.ml": "mililitro",
    "cs.plato.buyWord.u": "unidad",
    "cs.plato.buyWord.doc": "docena",
    "cs.plato.unitOpt.kg": "kg",
    "cs.plato.unitOpt.g": "g",
    "cs.plato.unitOpt.lt": "litro",
    "cs.plato.unitOpt.ml": "ml",
    "cs.plato.unitOpt.u": "unidad",
    "cs.plato.unitOpt.doc": "docena",
  },
  en: {
    "cs.plato.notFound.title": "We couldn't find this dish",
    "cs.plato.notFound.body": "Maybe you took it off the menu.",
    "cs.plato.notFound.back": "Back to Dishes",
    "cs.plato.sellsAt": "You sell it for",
    "cs.plato.draft.banner": "You have unsaved changes in this dish.",
    "cs.plato.draft.keep": "Keep going",
    "cs.plato.draft.discard": "Discard",
    "cs.plato.discarded": "You discarded the changes",
    "cs.plato.undo": "Undo",
    "cs.plato.undoClose": "Close notice",

    "cs.plato.mode.label": "How do you cost it?",
    "cs.plato.mode.recipe": "With a recipe",
    "cs.plato.mode.recipeSub": "ingredients",
    "cs.plato.mode.resale": "Sold as is",
    "cs.plato.mode.resaleSub": "drinks, bought ready",
    "cs.plato.mode.quick": "Approximate cost",
    "cs.plato.mode.quickSub": "one number",
    "cs.plato.say.recipe": "You know what eats into your profit.",
    "cs.plato.say.recipeStock": "You know what eats into your profit, and it deducts from stock every time it sells.",
    "cs.plato.say.resale": "For drinks and things you buy ready-made.",
    "cs.plato.say.resaleStock": "For drinks and things you buy ready-made. Each sale deducts 1.",
    "cs.plato.say.resaleSizes": "It has {n} sizes: for now cost and stock are a single one.",
    "cs.plato.say.quick": "It's faster, but you won't know what eats into your profit.",
    "cs.plato.say.quickStock": "This way the dish doesn't deduct from stock.",
    "cs.plato.say.quickStockTip": "If you want it to go down on its own, add the recipe.",

    "cs.plato.recipe.title": "What goes in it?",
    "cs.plato.recipe.search": "Add an ingredient: mozzarella, flour, egg…",
    "cs.plato.recipe.searchShort": "Add an ingredient…",
    "cs.plato.recipe.resultsAria": "Matching ingredients",
    "cs.plato.recipe.empty": "No ingredients yet. Type above and pick one: the unit and a typical amount come filled in.",
    "cs.plato.recipe.inRecipe": "already in the recipe",
    "cs.plato.recipe.prep": "Prep",
    "cs.plato.recipe.preset": "new · bought by the {unit}",
    "cs.plato.recipe.create": "Create \"{name}\"",
    "cs.plato.recipe.createSub": "asks for the price",

    "cs.plato.line.qtyAria": "Amount of {name}, in {unit}",
    "cs.plato.line.less": "Less {name}",
    "cs.plato.line.more": "More {name}",
    "cs.plato.line.menuAria": "More options for {name}",
    "cs.plato.line.waste": "+{n}% trim",
    "cs.plato.line.wasteTitle": "Trim: what gets thrown away while prepping",
    "cs.plato.line.wasteNone": "None",
    "cs.plato.line.prepSub": "Prep · {price}",
    "cs.plato.line.echo": "= {qty}",
    "cs.plato.line.unreadable": "That number doesn't read",
    "cs.plato.line.needQty": "Enter how much it takes",
    "cs.plato.line.exact": "Exact amount",
    "cs.plato.line.exactTitle": "Exact amount of {name}",
    "cs.plato.line.exactApply": "Done",
    "cs.plato.line.remove": "Remove from recipe",
    "cs.plato.line.removed": "You removed {name}",

    "cs.plato.broken.sub": "{qty} · you buy it by the {buy}",
    "cs.plato.broken.unit": "It's in {lineUnit} and you buy it by the {buy}: it doesn't add up or deduct.",
    "cs.plato.broken.unitNoStock": "It's in {lineUnit} and you buy it by the {buy}: it doesn't add to the cost.",
    "cs.plato.broken.fix": "Fix",
    "cs.plato.broken.measureHere": "Switch it to {unit} here",
    "cs.plato.broken.deleted": "This supply no longer exists: it doesn't add up.",
    "cs.plato.broken.deletedPrep": "This prep no longer exists: it doesn't add up.",
    "cs.plato.broken.inner": "This prep has a broken line inside: it doesn't fully add up.",
    "cs.plato.broken.remove": "Remove",
    "cs.plato.missing.text": "Without a price it doesn't add up: the dish stays incomplete.",
    "cs.plato.missing.amountText": "Without an amount it doesn't add up: enter how much it takes.",
    "cs.plato.missing.prepText": "The prep is missing an ingredient's price.",
    "cs.plato.missing.fix": "Add price",
    "cs.plato.missing.openPrep": "Open the prep",

    "cs.plato.new.title": "New ingredient",
    "cs.plato.new.name": "Name",
    "cs.plato.new.howMuch": "How much did you pay?",
    "cs.plato.new.paidAria": "How much you paid",
    "cs.plato.new.qtyAria": "How much you bought",
    "cs.plato.new.unitAria": "Unit",
    "cs.plato.new.echo": "→ {cost}",
    "cs.plato.new.unreadable": "That number doesn't read",
    "cs.plato.new.needPrice": "Enter what you paid, or tap \"I'll add it later\".",
    "cs.plato.new.later": "I don't know the price: I'll add it later",
    "cs.plato.new.add": "Add",
    "cs.plato.new.dup": "You already have \"{name}\" in Supplies.",
    "cs.plato.new.useIt": "Use that one",
    "cs.plato.new.createdNoPrice": "You created {name} without a price: the dish stays incomplete until you add it.",
    "cs.plato.new.failed": "The ingredient wasn't saved. Try again.",
    "cs.plato.paid": "You paid",
    "cs.plato.for": "for",

    "cs.plato.resale.title": "How much does each one cost you?",
    "cs.plato.resale.paidAria": "How much you paid",
    "cs.plato.resale.nAria": "How many it brings",
    "cs.plato.resale.hint": "What you paid for the pack or the box, and how many it brings.",
    "cs.plato.resale.match": "You already have \"{name}\" in Supplies ({price} each). Is it the same one?",
    "cs.plato.resale.matchYes": "Yes, the same",
    "cs.plato.resale.matchNo": "No, another one",
    "cs.plato.resale.tracked": "Tracked (there are {qty}): each sale deducts 1.",
    "cs.plato.resale.trackedUnc": "Tracked, but you haven't counted it yet.",
    "cs.plato.resale.trackedOversold": "Tracked. More was sold than counted: count it again.",
    "cs.plato.resale.track": "Track stock",
    "cs.plato.resale.have": "How many do you have now?",
    "cs.plato.resale.haveHint": "Count what's in the fridge and the storeroom.",

    "cs.plato.quick.label": "Roughly how much does each dish cost you?",
    "cs.plato.quick.suffix": "per dish",
    "cs.plato.quick.hint": "A round number is enough.",

    "cs.plato.hero.title": "You keep from each one",
    "cs.plato.hero.none": "No cost yet. Pick how to cost it: with a recipe, as is, or an approximate number.",
    "cs.plato.hero.ingredients": "Ingredients",
    "cs.plato.hero.approxCost": "Approximate cost",
    "cs.plato.hero.kitchen": "Kitchen costs ({pct}%)",
    "cs.plato.hero.queda": "You keep",
    "cs.plato.hero.beforeWages": "before wages and rent",
    "cs.plato.hero.incompleteMissing": "Incomplete: {name} has no price. You actually keep less.",
    "cs.plato.hero.incompleteAmount": "Incomplete: the amount of {name} is missing. You actually keep less.",
    "cs.plato.hero.incompleteBroken": "Incomplete: \"{name}\" doesn't add up. You actually keep less.",
    "cs.plato.hero.noPrice": "The menu has no price for this dish: add one in the menu editor.",
    "cs.plato.hero.worstOf": "at the {label} price",
    "cs.plato.hero.priceN": "Price {n}",
    "cs.plato.hero.sizeQueda": "you keep",
    "cs.plato.hero.sizesNote2": "Same recipe for both sizes (for now).",
    "cs.plato.hero.sizesNoteN": "Same recipe for the {n} sizes (for now).",
    "cs.plato.hero.goal": "Your goal: ingredients up to {pct}% of the price.",
    "cs.plato.hero.goalResale": "Your goal for what you resell: up to {pct}% of the price.",
    "cs.plato.hero.suggestPre": "To get there, charge",
    "cs.plato.hero.ok": "You're doing fine.",
    "cs.plato.hero.top": "What weighs the most: {name}, {pct}%",
    "cs.plato.hero.copy": "Copy price",
    "cs.plato.hero.copyAria": "Copy {price}",
    "cs.plato.hero.copied": "Copied: {price}. Paste it in the menu editor.",
    "cs.plato.hero.copyFail": "Couldn't copy: it's {price}.",
    "cs.plato.hero.changeGoal": "Change goal",
    "cs.plato.hero.metaMark": "goal",
    "cs.plato.hero.barAria": "Ingredients {ing}% and kitchen costs {gastos}% of the price. Your goal: {meta}%.",
    "cs.plato.bar.of": "of {price}",
    "cs.plato.bar.pcts": "Ingredients {pct}% · goal {meta}%",
    "cs.plato.bar.none": "No cost yet",
    "cs.plato.bar.noneSub": "Pick how to cost it and you'll see it here.",
    "cs.plato.bar.noPrice": "The menu has no price",
    "cs.plato.bar.open": "See the money breakdown",
    "cs.plato.bar.close": "Close the money breakdown",

    "cs.plato.stock.title": "Stock for this dish",
    "cs.plato.stock.loading": "Reading stock…",
    "cs.plato.stock.loadingShort": "Reading…",
    "cs.plato.stock.readError": "We couldn't read the stock. Try reloading the page.",
    "cs.plato.stock.quick": "Doesn't deduct from stock",
    "cs.plato.stock.quickBody": "It's on an approximate cost: the system doesn't know what goes in it.",
    "cs.plato.stock.toRecipe": "Switch to recipe",
    "cs.plato.stock.none": "Doesn't deduct yet: it has no recipe.",
    "cs.plato.stock.noTracked": "Doesn't deduct: none of its ingredients is tracked.",
    "cs.plato.stock.noTrackedBody": "Choose in Supplies what you want to track and this dish will lower stock on its own.",
    "cs.plato.stock.chooseTracked": "Choose what to track",
    "cs.plato.stock.brokenUnit": "{name} doesn't deduct: the recipe unit doesn't match the one you buy.",
    "cs.plato.stock.uncounted": "Count {name} first",
    "cs.plato.stock.uncountedBody": "You track it but never counted it: without that number we don't know how many it's enough for.",
    "cs.plato.stock.stale": "Count {name} again",
    "cs.plato.stock.staleBody": "You haven't counted it in over 4 months: the number isn't reliable anymore.",
    "cs.plato.stock.count": "Count",
    "cs.plato.stock.noSales": "We couldn't read the sales",
    "cs.plato.stock.noSalesBody": "Without sales we don't know how much is left.",
    "cs.plato.stock.afterSave": "Once you save, this dish will deduct from stock.",
    "cs.plato.stock.enough": "Enough for {n}",
    "cs.plato.stock.limiting": "First to run out: {name} (there's {have} and each one takes {need}).",
    "cs.plato.stock.limitingOne": "There are {have} of {name}.",
    "cs.plato.stock.outOf": "{name} ran out.",
    "cs.plato.stock.oversold": "More {name} was sold than counted: count it again.",
    "cs.plato.stock.waiter": "What the waiter sees:",
    "cs.plato.stock.waiterNada": "nothing (there's plenty).",
    "cs.plato.stock.waiterNadaMin": "With {min} or less of {name} they'll see how many are left (for example, \"3 left\").",
    "cs.plato.stock.waiterNadaNoMin": "{name} has no alert: they'll only see \"Sold out\".",
    "cs.plato.stock.waiterLow": "\"{n} left\",",
    "cs.plato.stock.waiterLowWhy": "because {name} is at or below its alert ({min}).",
    "cs.plato.stock.waiterOut": "\"Sold out\"",
    "cs.plato.stock.blockOn": "and can't add it to an order.",
    "cs.plato.stock.blockOff": "but can still add it. If you don't want that, turn on \"Don't sell what's sold out\" in Settings.",
    "cs.plato.stock.ifOutBlock": "If it sells out, they won't be able to add it.",
    "cs.plato.stock.ifOutNoBlock": "If it sells out, they'll see \"Sold out\" but can still add it.",
    "cs.plato.stock.goSettings": "Go to Settings",
    "cs.plato.stock.brokenAlso": "{name} doesn't deduct: the unit doesn't match.",
    "cs.plato.stock.pendingAlso": "{name} isn't in the count yet: it needs counting.",
    "cs.plato.stock.draftNote": "This is with the saved recipe: it changes when you save.",

    "cs.plato.more.title": "More dish options",
    "cs.plato.more.sub": "Kitchen costs, note, remove the cost",
    "cs.plato.more.kitchen": "Kitchen costs for this dish",
    "cs.plato.more.kitchenHint": "Empty = the one in Settings ({pct}%). Gas, power, disposables, seasoning.",
    "cs.plato.more.kitchenRange": "It has to be between 0 and 50.",
    "cs.plato.more.kitchenResale": "What's sold as is doesn't carry kitchen costs.",
    "cs.plato.more.note": "Note",
    "cs.plato.more.notePh": "E.g.: the portion is 250 g",
    "cs.plato.more.remove": "Remove the cost",
    "cs.plato.more.removeTitle": "Remove the cost?",
    "cs.plato.more.removeBody": "\"{name}\" goes back to No cost yet and what you entered is deleted.",
    "cs.plato.more.removeOk": "Remove the cost",
    "cs.plato.more.removed": "You removed the cost of {name}",

    "cs.plato.save.clean": "All saved",
    "cs.plato.save.next": "Save and next: {name}",
    "cs.plato.save.nextShort": "Save and next",
    "cs.plato.save.skip": "Next: {name}",
    "cs.plato.save.skipShort": "Next",
    "cs.plato.save.saved": "You saved {name}",
    "cs.plato.save.why.noLines": "Add at least one ingredient",
    "cs.plato.save.why.lineAmount": "An ingredient has no amount",
    "cs.plato.save.why.deletedLine": "Remove the supply that no longer exists",
    "cs.plato.save.why.quick": "Enter how much it costs you",
    "cs.plato.save.why.paid": "Enter what you paid",
    "cs.plato.save.why.have": "Enter how many you have",
    "cs.plato.save.why.indirect": "Check the kitchen costs",

    "cs.plato.per.kg": "per kg",
    "cs.plato.per.g": "per g",
    "cs.plato.per.lt": "per liter",
    "cs.plato.per.ml": "per ml",
    "cs.plato.per.u": "each",
    "cs.plato.per.doc": "per dozen",
    "cs.plato.unitWord.kg": "kilos",
    "cs.plato.unitWord.g": "grams",
    "cs.plato.unitWord.lt": "liters",
    "cs.plato.unitWord.ml": "milliliters",
    "cs.plato.unitWord.u": "pieces",
    "cs.plato.unitWord.doc": "dozens",
    "cs.plato.buyWord.kg": "kilo",
    "cs.plato.buyWord.g": "gram",
    "cs.plato.buyWord.lt": "liter",
    "cs.plato.buyWord.ml": "milliliter",
    "cs.plato.buyWord.u": "piece",
    "cs.plato.buyWord.doc": "dozen",
    "cs.plato.unitOpt.kg": "kg",
    "cs.plato.unitOpt.g": "g",
    "cs.plato.unitOpt.lt": "liter",
    "cs.plato.unitOpt.ml": "ml",
    "cs.plato.unitOpt.u": "piece",
    "cs.plato.unitOpt.doc": "dozen",
  },
  pt: {
    "cs.plato.notFound.title": "Não encontramos este prato",
    "cs.plato.notFound.body": "Talvez você o tenha tirado do cardápio.",
    "cs.plato.notFound.back": "Voltar para Pratos",
    "cs.plato.sellsAt": "Você vende por",
    "cs.plato.draft.banner": "Você tem alterações não salvas neste prato.",
    "cs.plato.draft.keep": "Continuar",
    "cs.plato.draft.discard": "Descartar",
    "cs.plato.discarded": "Você descartou as alterações",
    "cs.plato.undo": "Desfazer",
    "cs.plato.undoClose": "Fechar o aviso",

    "cs.plato.mode.label": "Como você custeia?",
    "cs.plato.mode.recipe": "Com receita",
    "cs.plato.mode.recipeSub": "com ingredientes",
    "cs.plato.mode.resale": "Vendido como está",
    "cs.plato.mode.resaleSub": "bebidas, comprado pronto",
    "cs.plato.mode.quick": "Custo aproximado",
    "cs.plato.mode.quickSub": "um número",
    "cs.plato.say.recipe": "Você sabe o que come o seu lucro.",
    "cs.plato.say.recipeStock": "Você sabe o que come o seu lucro, e ele baixa o estoque a cada venda.",
    "cs.plato.say.resale": "Para bebidas e o que você compra pronto.",
    "cs.plato.say.resaleStock": "Para bebidas e o que você compra pronto. Cada venda baixa 1.",
    "cs.plato.say.resaleSizes": "Tem {n} tamanhos: por enquanto o custo e o estoque são um só.",
    "cs.plato.say.quick": "É mais rápido, mas você não vai saber o que come o seu lucro.",
    "cs.plato.say.quickStock": "Assim este prato não baixa o estoque.",
    "cs.plato.say.quickStockTip": "Se quiser que baixe sozinho, cadastre a receita.",

    "cs.plato.recipe.title": "O que leva?",
    "cs.plato.recipe.search": "Adicione um ingrediente: muçarela, farinha, ovo…",
    "cs.plato.recipe.searchShort": "Adicione um ingrediente…",
    "cs.plato.recipe.resultsAria": "Ingredientes que coincidem",
    "cs.plato.recipe.empty": "Ainda não tem ingredientes. Digite acima e escolha: a unidade e uma quantidade típica já vêm preenchidas.",
    "cs.plato.recipe.inRecipe": "já está na receita",
    "cs.plato.recipe.prep": "Preparo",
    "cs.plato.recipe.preset": "novo · comprado por {unit}",
    "cs.plato.recipe.create": "Criar \"{name}\"",
    "cs.plato.recipe.createSub": "pede o preço",

    "cs.plato.line.qtyAria": "Quantidade de {name}, em {unit}",
    "cs.plato.line.less": "Menos {name}",
    "cs.plato.line.more": "Mais {name}",
    "cs.plato.line.menuAria": "Mais opções de {name}",
    "cs.plato.line.waste": "+{n}% limpeza",
    "cs.plato.line.wasteTitle": "Limpeza: o que se joga fora ao preparar",
    "cs.plato.line.wasteNone": "Nada",
    "cs.plato.line.prepSub": "Preparo · {price}",
    "cs.plato.line.echo": "= {qty}",
    "cs.plato.line.unreadable": "Não dá para ler o número",
    "cs.plato.line.needQty": "Informe quanto leva",
    "cs.plato.line.exact": "Quantidade exata",
    "cs.plato.line.exactTitle": "Quantidade exata de {name}",
    "cs.plato.line.exactApply": "Pronto",
    "cs.plato.line.remove": "Tirar da receita",
    "cs.plato.line.removed": "Você tirou {name}",

    "cs.plato.broken.sub": "{qty} · você compra por {buy}",
    "cs.plato.broken.unit": "Está em {lineUnit} e você compra por {buy}: não soma nem baixa.",
    "cs.plato.broken.unitNoStock": "Está em {lineUnit} e você compra por {buy}: não soma ao custo.",
    "cs.plato.broken.fix": "Corrigir",
    "cs.plato.broken.measureHere": "Passar para {unit} aqui",
    "cs.plato.broken.deleted": "Este insumo não existe mais: não soma.",
    "cs.plato.broken.deletedPrep": "Este preparo não existe mais: não soma.",
    "cs.plato.broken.inner": "Dentro deste preparo há uma linha quebrada: não soma inteiro.",
    "cs.plato.broken.remove": "Tirar",
    "cs.plato.missing.text": "Sem preço não soma: o prato fica incompleto.",
    "cs.plato.missing.amountText": "Sem quantidade não soma: informe quanto leva.",
    "cs.plato.missing.prepText": "Falta o preço de um ingrediente do preparo.",
    "cs.plato.missing.fix": "Pôr preço",
    "cs.plato.missing.openPrep": "Ver o preparo",

    "cs.plato.new.title": "Ingrediente novo",
    "cs.plato.new.name": "Nome",
    "cs.plato.new.howMuch": "Quanto você pagou?",
    "cs.plato.new.paidAria": "Quanto você pagou",
    "cs.plato.new.qtyAria": "Quanto você comprou",
    "cs.plato.new.unitAria": "Unidade",
    "cs.plato.new.echo": "→ {cost}",
    "cs.plato.new.unreadable": "Não dá para ler o número",
    "cs.plato.new.needPrice": "Informe quanto pagou, ou toque em \"Lanço depois\".",
    "cs.plato.new.later": "Não sei o preço: lanço depois",
    "cs.plato.new.add": "Adicionar",
    "cs.plato.new.dup": "Você já tem \"{name}\" em Insumos.",
    "cs.plato.new.useIt": "Usar esse",
    "cs.plato.new.createdNoPrice": "Você criou {name} sem preço: o prato fica incompleto até você lançar.",
    "cs.plato.new.failed": "O ingrediente não foi salvo. Tente de novo.",
    "cs.plato.paid": "Você pagou",
    "cs.plato.for": "por",

    "cs.plato.resale.title": "Quanto custa cada um?",
    "cs.plato.resale.paidAria": "Quanto você pagou",
    "cs.plato.resale.nAria": "Quantos vêm",
    "cs.plato.resale.hint": "O que você pagou pelo pacote ou pela caixa, e quantos vêm.",
    "cs.plato.resale.match": "Você já tem \"{name}\" em Insumos ({price} cada). É o mesmo?",
    "cs.plato.resale.matchYes": "Sim, é o mesmo",
    "cs.plato.resale.matchNo": "Não, é outro",
    "cs.plato.resale.tracked": "Controlado (há {qty}): cada venda baixa 1.",
    "cs.plato.resale.trackedUnc": "Controlado, mas você ainda não contou.",
    "cs.plato.resale.trackedOversold": "Controlado. Vendeu mais do que tinha: conte de novo.",
    "cs.plato.resale.track": "Controlar o estoque",
    "cs.plato.resale.have": "Quantos você tem agora?",
    "cs.plato.resale.haveHint": "Conte o que há na geladeira e no depósito.",

    "cs.plato.quick.label": "Quanto custa cada prato, mais ou menos?",
    "cs.plato.quick.suffix": "por prato",
    "cs.plato.quick.hint": "Um número redondo basta.",

    "cs.plato.hero.title": "Sobra de cada um",
    "cs.plato.hero.none": "Ainda não tem custo. Escolha como custear: com receita, como está ou um número aproximado.",
    "cs.plato.hero.ingredients": "Ingredientes",
    "cs.plato.hero.approxCost": "Custo aproximado",
    "cs.plato.hero.kitchen": "Gastos de cozinha ({pct}%)",
    "cs.plato.hero.queda": "Sobra",
    "cs.plato.hero.beforeWages": "antes de salários e aluguel",
    "cs.plato.hero.incompleteMissing": "Incompleto: falta o preço de {name}. O que sobra é menos.",
    "cs.plato.hero.incompleteAmount": "Incompleto: falta quanto leva de {name}. O que sobra é menos.",
    "cs.plato.hero.incompleteBroken": "Incompleto: \"{name}\" não soma. O que sobra é menos.",
    "cs.plato.hero.noPrice": "O cardápio não tem preço para este prato: coloque no editor do cardápio.",
    "cs.plato.hero.worstOf": "com o preço de {label}",
    "cs.plato.hero.priceN": "Preço {n}",
    "cs.plato.hero.sizeQueda": "sobra",
    "cs.plato.hero.sizesNote2": "Mesma receita para os dois tamanhos (por enquanto).",
    "cs.plato.hero.sizesNoteN": "Mesma receita para os {n} tamanhos (por enquanto).",
    "cs.plato.hero.goal": "Sua meta: ingredientes até {pct}% do preço.",
    "cs.plato.hero.goalResale": "Sua meta para o que você revende: até {pct}% do preço.",
    "cs.plato.hero.suggestPre": "Para chegar, cobre",
    "cs.plato.hero.ok": "Está indo bem.",
    "cs.plato.hero.top": "O que mais pesa: {name}, {pct}%",
    "cs.plato.hero.copy": "Copiar preço",
    "cs.plato.hero.copyAria": "Copiar {price}",
    "cs.plato.hero.copied": "Copiado: {price}. Cole no editor do cardápio.",
    "cs.plato.hero.copyFail": "Não deu para copiar: é {price}.",
    "cs.plato.hero.changeGoal": "Mudar meta",
    "cs.plato.hero.metaMark": "meta",
    "cs.plato.hero.barAria": "Ingredientes {ing}% e gastos de cozinha {gastos}% do preço. Sua meta: {meta}%.",
    "cs.plato.bar.of": "de {price}",
    "cs.plato.bar.pcts": "Ingredientes {pct}% · meta {meta}%",
    "cs.plato.bar.none": "Ainda não tem custo",
    "cs.plato.bar.noneSub": "Escolha como custear e você vê aqui.",
    "cs.plato.bar.noPrice": "O cardápio não tem preço",
    "cs.plato.bar.open": "Ver o detalhe do dinheiro",
    "cs.plato.bar.close": "Fechar o detalhe do dinheiro",

    "cs.plato.stock.title": "Estoque deste prato",
    "cs.plato.stock.loading": "Lendo o estoque…",
    "cs.plato.stock.loadingShort": "Lendo…",
    "cs.plato.stock.readError": "Não conseguimos ler o estoque. Tente recarregar a página.",
    "cs.plato.stock.quick": "Não baixa o estoque",
    "cs.plato.stock.quickBody": "Está em custo aproximado: o sistema não sabe o que leva.",
    "cs.plato.stock.toRecipe": "Passar para receita",
    "cs.plato.stock.none": "Ainda não baixa: não tem receita.",
    "cs.plato.stock.noTracked": "Não baixa: nenhum ingrediente é controlado.",
    "cs.plato.stock.noTrackedBody": "Escolha em Insumos o que quer controlar e este prato vai baixar o estoque sozinho.",
    "cs.plato.stock.chooseTracked": "Escolher o que controlar",
    "cs.plato.stock.brokenUnit": "{name} não baixa: a unidade da receita não bate com a que você compra.",
    "cs.plato.stock.uncounted": "Falta contar {name}",
    "cs.plato.stock.uncountedBody": "Você controla mas nunca contou: sem esse número não sabemos para quantos dá.",
    "cs.plato.stock.stale": "Conte {name} de novo",
    "cs.plato.stock.staleBody": "Faz mais de 4 meses que você não conta: o número já não é confiável.",
    "cs.plato.stock.count": "Contar",
    "cs.plato.stock.noSales": "Não conseguimos ler as vendas",
    "cs.plato.stock.noSalesBody": "Sem as vendas não sabemos quanto sobra.",
    "cs.plato.stock.afterSave": "Quando você salvar, este prato vai baixar o estoque.",
    "cs.plato.stock.enough": "Dá para {n}",
    "cs.plato.stock.limiting": "O primeiro que acaba: {name} (há {have} e cada um leva {need}).",
    "cs.plato.stock.limitingOne": "Há {have} de {name}.",
    "cs.plato.stock.outOf": "Acabou {name}.",
    "cs.plato.stock.oversold": "Vendeu mais {name} do que tinha: conte de novo.",
    "cs.plato.stock.waiter": "Assim o garçom vê:",
    "cs.plato.stock.waiterNada": "nada (tem de sobra).",
    "cs.plato.stock.waiterNadaMin": "Com {min} ou menos de {name} vai ver quantos restam (por exemplo, \"Restam 3\").",
    "cs.plato.stock.waiterNadaNoMin": "{name} não tem aviso: só vai ver \"Esgotado\".",
    "cs.plato.stock.waiterLow": "\"Restam {n}\",",
    "cs.plato.stock.waiterLowWhy": "porque {name} está no aviso ou abaixo ({min}).",
    "cs.plato.stock.waiterOut": "\"Esgotado\"",
    "cs.plato.stock.blockOn": "e não pode lançar.",
    "cs.plato.stock.blockOff": "mas pode lançar igual. Se não quiser, ative \"Não deixar vender o esgotado\" em Ajustes.",
    "cs.plato.stock.ifOutBlock": "Se esgotar, não vai poder lançar.",
    "cs.plato.stock.ifOutNoBlock": "Se esgotar, vai ver \"Esgotado\" mas pode lançar igual.",
    "cs.plato.stock.goSettings": "Ir para Ajustes",
    "cs.plato.stock.brokenAlso": "{name} não baixa: a unidade não bate.",
    "cs.plato.stock.pendingAlso": "{name} ainda não entra na conta: falta contar.",
    "cs.plato.stock.draftNote": "É com a receita salva: muda quando você salvar.",

    "cs.plato.more.title": "Mais opções do prato",
    "cs.plato.more.sub": "Gastos de cozinha, nota, tirar o custo",
    "cs.plato.more.kitchen": "Gastos de cozinha deste prato",
    "cs.plato.more.kitchenHint": "Vazio = o de Ajustes ({pct}%). Gás, luz, descartáveis, temperos.",
    "cs.plato.more.kitchenRange": "Tem que estar entre 0 e 50.",
    "cs.plato.more.kitchenResale": "O que é vendido como está não carrega gastos de cozinha.",
    "cs.plato.more.note": "Nota",
    "cs.plato.more.notePh": "Ex.: a porção é de 250 g",
    "cs.plato.more.remove": "Tirar o custo",
    "cs.plato.more.removeTitle": "Tirar o custo?",
    "cs.plato.more.removeBody": "\"{name}\" volta para Sem custo e o que você lançou é apagado.",
    "cs.plato.more.removeOk": "Tirar o custo",
    "cs.plato.more.removed": "Você tirou o custo de {name}",

    "cs.plato.save.clean": "Tudo salvo",
    "cs.plato.save.next": "Salvar e seguir: {name}",
    "cs.plato.save.nextShort": "Salvar e seguir",
    "cs.plato.save.skip": "Seguir: {name}",
    "cs.plato.save.skipShort": "Seguir",
    "cs.plato.save.saved": "Você salvou {name}",
    "cs.plato.save.why.noLines": "Adicione pelo menos um ingrediente",
    "cs.plato.save.why.lineAmount": "Há um ingrediente sem quantidade",
    "cs.plato.save.why.deletedLine": "Tire o insumo que não existe mais",
    "cs.plato.save.why.quick": "Informe quanto custa",
    "cs.plato.save.why.paid": "Informe quanto pagou",
    "cs.plato.save.why.have": "Informe quantos tem",
    "cs.plato.save.why.indirect": "Revise os gastos de cozinha",

    "cs.plato.per.kg": "o kg",
    "cs.plato.per.g": "o g",
    "cs.plato.per.lt": "o litro",
    "cs.plato.per.ml": "o ml",
    "cs.plato.per.u": "cada",
    "cs.plato.per.doc": "a dúzia",
    "cs.plato.unitWord.kg": "quilos",
    "cs.plato.unitWord.g": "gramas",
    "cs.plato.unitWord.lt": "litros",
    "cs.plato.unitWord.ml": "mililitros",
    "cs.plato.unitWord.u": "unidades",
    "cs.plato.unitWord.doc": "dúzias",
    "cs.plato.buyWord.kg": "quilo",
    "cs.plato.buyWord.g": "grama",
    "cs.plato.buyWord.lt": "litro",
    "cs.plato.buyWord.ml": "mililitro",
    "cs.plato.buyWord.u": "unidade",
    "cs.plato.buyWord.doc": "dúzia",
    "cs.plato.unitOpt.kg": "kg",
    "cs.plato.unitOpt.g": "g",
    "cs.plato.unitOpt.lt": "litro",
    "cs.plato.unitOpt.ml": "ml",
    "cs.plato.unitOpt.u": "unidade",
    "cs.plato.unitOpt.doc": "dúzia",
  },
};

export default plato;
